import teamSetupPickerStore from "../store/store";
import { IRestorableScheduleTeam } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_RESTORABLE_SCHEDULES', function setRestorableSchedules(schedules: IRestorableScheduleTeam[]) {
    teamSetupPickerStore.restorableSchedules = schedules || [];
});
